<app-tool-bar [title]="'Contacts'" [iconName]="'pi-users'" [isSearch]="true" [isDateFilter]="true"
   [filtersOptions]="filtersOptions" [isAdd]="true" (handleAdd)="handleAddContact()" (search)="handleSearch($event)"
    (dateFilter)="handleDateFilter($event)" (resetDateFilter)="handleResetFilters()"></app-tool-bar>

<!-- Filter Section -->
<div div class="p-4 overflow-auto h-[85vh]">
    <!-- <div class="filter-section p-3 border-bottom-1 surface-border flex flex-column md:flex-column lg:flex-row gap-3 mb-4"> -->
    <div class="filter-section p-3 border-b mb-4">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-5">

            <!-- Academic Year -->
            <div>
                <label class="block mb-2 font-semibold">Academic Year</label>
                <p-multiSelect [options]="academicYears" [(ngModel)]="selectedAcademicYears" optionLabel="year_name"
                    optionValue="id"
                    placeholder="Select Academic Years" [filter]="true" filterPlaceHolder="Search"
                    [showToggleAll]="true" styleClass="w-full" (onChange)="onFilterChange()">

                    <ng-template let-value pTemplate="selectedItems">
                        <div class="inline-flex items-center gap-2" *ngIf="value?.length">
                            <span>{{ value.length }} selected</span>
                        </div>
                        <span *ngIf="!value?.length">Select Academic Years</span>
                    </ng-template>
                </p-multiSelect>
            </div>

            <!-- Batch -->
            <div>
                <label class="block mb-2 font-semibold">Batch</label>
                <p-multiSelect [options]="batches" [(ngModel)]="selectedBatches" optionLabel="batch_name"
                    optionValue="id"
                    placeholder="Select Batches" [filter]="true" filterPlaceHolder="Search" [showToggleAll]="true"
                    styleClass="w-full" (onChange)="onFilterChange()">

                    <ng-template let-value pTemplate="selectedItems">
                        <div class="inline-flex items-center gap-2" *ngIf="value?.length">
                            <span>{{ value.length }} selected</span>
                        </div>
                        <span *ngIf="!value?.length">Select Batches</span>
                    </ng-template>
                </p-multiSelect>
            </div>

            <!-- Course -->
            <div>
                <label class="block mb-2 font-semibold">Course</label>
                <p-multiSelect [options]="courses" [(ngModel)]="selectedCourses" optionLabel="name"
                    optionValue="course_id"
                    placeholder="Select Courses" [filter]="true" filterPlaceHolder="Search" [showToggleAll]="true"
                    styleClass="w-full" (onChange)="onFilterChange()">

                    <ng-template let-value pTemplate="selectedItems">
                        <div class="inline-flex items-center gap-2" *ngIf="value?.length">
                            <span>{{ value.length }} selected</span>
                        </div>
                        <span *ngIf="!value?.length">Select Courses</span>
                    </ng-template>
                </p-multiSelect>
            </div>

            <!-- Department -->
            <div>
                <label class="block mb-2 font-semibold">Department</label>
                <p-multiSelect [options]="departments" [(ngModel)]="selectedDepartments" optionLabel="name"
                    placeholder="Select Departments" [filter]="true" filterPlaceHolder="Search" [showToggleAll]="true"
                    styleClass="w-full" (onChange)="onFilterChange()" optionValue="dept_id">

                    <ng-template let-value pTemplate="selectedItems">
                        <div class="inline-flex items-center gap-2" *ngIf="value?.length">
                            <span>{{ value.length }} selected</span>
                        </div>
                        <span *ngIf="!value?.length">Select Departments</span>
                    </ng-template>
                </p-multiSelect>
            </div>

        </div>
    </div>


    <!-- </div> -->

    <!-- Table Section -->
    <p-table #dt [value]="dataSource" [columns]="columns" [loading]="loading" [paginator]="true" [rows]="rows"
        [totalRecords]="totalRecords" [lazy]="true" (onLazyLoad)="onPageChange($event)"
        [rowsPerPageOptions]="pageSizeOptions" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['first_name', 'last_name', 'email', 'phone', 'designation']"
        styleClass="p-datatable-gridlines" responsiveLayout="scroll" (onSort)="onSort($event)">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <!-- [pSortableColumn]="col.sortable ? col.field : null" -->
                <th *ngFor="let col of columns" >
                    {{ col.header }}
                    <!-- <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon> -->
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.type">
                        <ng-container *ngSwitchCase="'full_name'">
                            {{ getFullName(rowData) }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'actions'">
                            <button pButton type="button" icon="pi pi-ellipsis-v" class="p-button-text p-button-rounded"
                                (click)="menu.toggle($event); saveEditData(rowData)"></button>
                            <p-menu #menu [model]="menuItems" 
                            appendTo="body"
                            [popup]="true"></p-menu>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                    <div class="p-4 text-center">
                        <i class="pi pi-info-circle text-4xl text-400 mb-3"></i>
                        <p class="text-600">No contacts found</p>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Dialogs -->
<p-dialog 
    [(visible)]="isCreateContact" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    [draggable]="false" 
    [resizable]="false"
    [closable]="false">
    <app-create-contact 
        *ngIf="isCreateContact"
        [editContactData]="{}"
        [formAction]="'Add'"
        [allContactFields]="[]"
        [users]="users"
        [allCourses]="courses"
        [academicYears]="academicYears"
        [batches]="batches"
        [courses]="courses"
        [departments]="departments"
        (reload)="reloadDataTable()"
        (closeDialog)="handleCloseDialog(true)">
    </app-create-contact>
</p-dialog>

<p-dialog 
    [(visible)]="isUpdateContact" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    [draggable]="false" 
    [resizable]="false"
    [closable]="false">
    <app-create-contact 
        *ngIf="isUpdateContact"
        [editContactData]="editContactData"
        [formAction]="'Update'"
        [allContactFields]="[]"
        [users]="users"
        [allCourses]="courses"
        [academicYears]="academicYears"
        [batches]="batches"
        [courses]="courses"
        [departments]="departments"
        (reload)="reloadDataTable()"
        (closeDialog)="handleCloseDialog(true)">
    </app-create-contact>
</p-dialog>

<p-dialog 
    [(visible)]="isDeleteContact" 
    [modal]="true" 
    [style]="{ width: '450px' }"
    [draggable]="false" 
    [resizable]="false"
    [closable]="false">
    <app-delete-contact 
        *ngIf="isDeleteContact"
        [editContactData]="editContactData"
        (reload)="reloadDataTable()"
        (closeDialog)="handleCloseDialog(false)">
    </app-delete-contact>
</p-dialog>